module.exports = __webpack_public_path__ + "img/new_10.e4083dc2.jpg";